import { getRuntimeLocation } from 'shared/utils/environment/globalLocation';
import { getApiUrlFromEnv } from 'shared/utils/environment/variables';

const envApiUrl = getApiUrlFromEnv();

function buildDefaultApiUrl(): string {
  const location = getRuntimeLocation();

  if (!location) {
    return '/api';
  }

  return `${location.protocol}//${location.host}/api`;
}

export const apiUrl = envApiUrl || buildDefaultApiUrl();
